import type { Theme } from '@mui/material/styles';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((_theme: Theme) => ({
  card: {
    // width: '82%',
    // display: 'flex',
    // flexWrap: 'wrap',
    //  justifyContent: 'space-between',
    // margin: '20px auto',
    padding: '15px',
    height: 'max-content',
  },
}));

export default useStyles;
